export const fullScreenManager = {
  initial: 'idle',
  invoke: {
    src: 'watchFullScreenMode',
  },
  states: {
    idle: {
      on: {
        ENVIRONMENT_FULL_SCREEN_CHANGED: [
          {
            actions: [
              'saveFullScreenMode',
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.GameModal.properties.isFullScreen',
                  value: '$context.isFullScreen',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
            ],
          },
        ],
      },
    },
  },
};
